/**
 * Configuracao de visibilidade do menu "Relatórios de Tarifas".
 *
 * Controlada por env (CRA bakeia REACT_APP_* no build, mesmo padrao do
 * REACT_APP_CABINE_URL):
 *
 * - REACT_APP_RELATORIO_TARIFAS_ADMIN_ONLY: flag liga/desliga.
 *     'true'  -> menu aparece SOMENTE para admin (parceiro Fiducia)
 *     ausente/qualquer outro valor -> menu aparece para TODOS (nao-admin
 *     e parceiros normalmente)
 * - REACT_APP_ID_PARCEIRO_FIDUCIA: id do parceiro Fiducia usado pra
 *     definir quem e admin. Default 1 se a env nao estiver setada.
 *
 * Regra de admin (conforme alinhado): admin = partnerId === ID_PARCEIRO_FIDUCIA.
 */

const ADMIN_ONLY =
  (process.env.REACT_APP_RELATORIO_TARIFAS_ADMIN_ONLY ?? '').toLowerCase() ===
  'true';

const ID_PARCEIRO_FIDUCIA = Number(
  process.env.REACT_APP_ID_PARCEIRO_FIDUCIA ?? 1
);

/**
 * Decide se o menu "Relatórios de Tarifas" deve aparecer para o usuario.
 *
 * - Flag desligada: sempre visivel.
 * - Flag ligada: visivel apenas para admin (partnerId === ID_PARCEIRO_FIDUCIA).
 */
function podeVerRelatorioTarifas(partnerId?: number): boolean {
  if (!ADMIN_ONLY) return true;
  return partnerId === ID_PARCEIRO_FIDUCIA;
}

export default podeVerRelatorioTarifas;
